import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import Ouvid from '../../components/ouvidoria';



function OuvidoriaScreen() {
    return (
        <Fragment>
            <Head titulo="Ouvidoria Municipal" />
            <Header />
            <Container>
               <Ouvid /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidoriaScreen;